import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({ providedIn: 'root' })

export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authService.currentUserValue;
    if (route.data && route.data['actions']) {
      // console.log(route.data)
    }
    if (currentUser && this.authService.canAccess(location.pathname, true, route.data['actions'])) {
      return true;
    }
    // if (currentUser && !this.authService.canAccess(location.pathname, true)) {
    //   this.router.navigate(['/admin/notAuthorized']);
    // } else {
    //   // not logged in so redirect to login page with the return url
    //   this.authService.clearUserData();
    //   this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    // }
    // not logged in so redirect to login page with the return url
    this.authService.clearUserData();
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
